import { useMemo } from "react";
import { useTheme } from "@/contexts/theme";

const useStyle = () => {
  const isModern = useTheme().currentTheme === "modern";
  const classes = useMemo(() => {
    return {
      mainContainer: {
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        gap: 20,
        padding: isModern ? "0px 0 20px 0" : "0px 20px 20px 20px",
        overflowY: "auto" as "auto",
      },
    };
  }, [isModern]);
  return {
    classes,
  };
};
export { useStyle };
